module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "Chart_Icon.219abf0d.png";